import { useParams } from "react-router-dom";

import { useNavigation } from "@/providers";
import { PageLayout } from "@/shared/components";
import { AssociationType } from "@/shared/domain/association";

import { CreateDatasetEventForm } from "./CreateDatasetEventForm";

export const CreateDatasetEvent = () => {
  const { datasetPath } = useParams();
  const { goto } = useNavigation();
  return (
    <PageLayout
      title={"Roboto - Create Event"}
      headerContentLeft={"Create Event"}
    >
      <CreateDatasetEventForm
        associationRecord={{
          association_id: datasetPath ?? "",
          association_type: AssociationType.Dataset,
        }}
        onCancel={() => {
          if (datasetPath) {
            goto.datasetEvents({ datasetId: datasetPath });
          }
        }}
        onSuccess={() => {
          if (datasetPath) {
            goto.datasetEvents({ datasetId: datasetPath });
          }
        }}
      />
    </PageLayout>
  );
};
